import React from "react";
import {FallbackProps} from "react-error-boundary";
import Button from "./Button";
import PawIcon from "../../images/pawIcon.svg";

const ErrorFallback: React.FC<FallbackProps> = ({error, resetErrorBoundary}) => {

    return (
        <div className="blj-store-locator-error-fallback">

            <img src={PawIcon}
                 alt="Paw icon"
                 className="blj-store-locator-error-fallback__icon"
            />

            <div className="blj-store-locator-error-fallback__content">

                <h3 className="blj-store-locator-error-fallback__title">
                    Something went wrong :(
                </h3>
                <span className="blj-store-locator-error-fallback__caption">
                    {error.message}
                </span>
            </div>

            <Button
                variant="primary"
                onClick={resetErrorBoundary}
                text="Try again"
            />
        </div>
    );

}

export default ErrorFallback;